import * as actionTypes from "./actionTypes";
import { changeRequestsServices } from "../services/change-requests.admin.service";

export const resetChangeRequests = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_CHANGE_REQUESTS,
  });
};

export const getChangeRequests = (error) => async (dispatch) => {
  try {
    const res = await changeRequestsServices.getChangeRequests();
    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: actionTypes.GET_CHANGE_REQUESTS,
        payload: res.data.returnObject,
      });
    } else {
      dispatch({
        type: actionTypes.GET_CHANGE_REQUESTS,
        payload: null,
      });

      error(res.data.message);
    }

    dispatch({
      type: actionTypes.LOAD_CHANGE_REQUESTS,
      payload: false,
    });
  } catch (e) {
    dispatch({
      type: actionTypes.LOAD_CHANGE_REQUESTS,
      payload: false,
    });
    error(e.message);
  }
};

export const filterChangeRequest =
  (searchTerm, requestStatus, licenseStatus) => (dispatch) => {
    dispatch({
      type: actionTypes.FILTER_CHANGE_REQUESTS,
      payload: { requestStatus, searchTerm, licenseStatus },
    });
  };



export const deleteChangeRequest = (id, error, success) => async (dispatch) => {
  dispatch({
    type: actionTypes.SET_DELETING,
    payload: id
  });

  try {
    const res = await changeRequestsServices.deleteChangeRequest(id);
    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: actionTypes.DELETE_CHANGE_REQUEST,
        payload: id
      });

      success(res.data.message);
    } else {
      dispatch({
        type: actionTypes.DELETE_CHANGE_REQUEST,
        payload: null,
      });
      error(res.data.message);
    }
  } catch (e) {
    dispatch({
      type: actionTypes.DELETE_CHANGE_REQUEST,
      payload: null,
    });
    console.log(e.message)
  }
};


export const acceptChangeRequest = (id, error, success) => async (dispatch) => {
  dispatch({
    type: actionTypes.SET_ACCEPTING,
    payload: id
  });

  try {
    const res = await changeRequestsServices.acceptChangeRequest(id);
    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: actionTypes.ACCEPT_CHANGE_REQUEST,
        payload: id
      });

      success(res.data.message);
    } else {
      dispatch({
        type: actionTypes.ACCEPT_CHANGE_REQUEST,
        payload: null,
      });
      error(res.data.message);
    }
  } catch (e) {
    dispatch({
      type: actionTypes.ACCEPT_CHANGE_REQUEST,
      payload: null,
    });
    console.log(e.message)

  }
};

